// extracted by mini-css-extract-plugin
module.exports = {"amPage":"amPage--2Fryq","amBg":"amBg--1oIdW","words":"words--3XNiI"};
    if(module.hot) {
      // 1675232528913
      var cssReload = require("/workspace/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  